import { gql, useMutation, useQuery } from '@apollo/client'

import {
  ConsoleBankEditQuery,
  ConsoleBankEditQueryVariables,
  UpdateBankMutation,
  UpdateBankMutationVariables,
} from '@/clients/utoniq-core/schema'
import { makeViewModel } from '@/core/architecture'
import { useCurrentUser } from '@/core/auth'

import { Action, State } from './template'

export const useViewModel = makeViewModel<State, Action>(() => {
  const { user } = useCurrentUser()

  const { data } = useQuery<
    ConsoleBankEditQuery,
    ConsoleBankEditQueryVariables
  >(QUERY)

  const [updateBank] = useMutation<
    UpdateBankMutation,
    UpdateBankMutationVariables
  >(UPDATE_BANK)

  return {
    state: {
      artistId: user?.uid ?? '',
      artist: data?.artist ?? null,
    },
    actions: {
      async onSubmit(values) {
        await updateBank({
          variables: {
            inputs: values,
          },
        })
      },
    },
  }
})

const QUERY = gql`
  query ConsoleBankEdit {
    artist {
      id
      bank {
        id
        accountHolderName
        accountHolderType
        bankName
        last4
        routingNumber
      }
    }
  }
`

const UPDATE_BANK = gql`
  mutation UpdateBank($inputs: BankInput) {
    updateBank(inputs: $inputs) {
      id
      bank {
        id
        accountHolderName
        accountHolderType
        bankName
        last4
        routingNumber
      }
    }
  }
`
